import { AppConfig } from './types';

/**
 * Sub-environment configuration
 * Only specify values that differ from the default configuration
 */
export const subEnvironmentConfig: Partial<AppConfig> = {
  proctoring: {
    api: {
      baseUrl: 'https://api.sub.smarterproctoring.com',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  assessment: {
    api: {
      baseUrl: '',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  core : {
    api: {
      baseUrl: 'https://signon.sub.smarterproctoring.com',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  media : {
    api: {
      baseUrl: 'https://api.sub.proctoring.media',
      timeout: 30000,
      retryAttempts: 3
    },
    playback: {
      baseUrl: 'https://playback.sub.proctoring.media',
    },
    livekit: {
      websocketUrl: 'wss://media-dev-sfo2.proctoring.media',
    }
  },
  elements: {
    ui : {
      baseUrl: 'https://app.sub.smarterservices.com',
    }
  }
};
